import { cva } from 'class-variance-authority';

export const propertyAreaInputVariants = cva('', {
	variants: {
		variant: {
			primary:
				'border border-white-dark-4 hover:border-primary/40 focus:border-primary hover:focus:border-primary focus-visible:ring-0',
			dark: 'text-white placeholder:text-white-dark-4'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});
